import { render, staticRenderFns } from "./RecordMoveButtons.vue?vue&type=template&id=4ec30ea2&"
import script from "./RecordMoveButtons.vue?vue&type=script&scoped=true&lang=js&"
export * from "./RecordMoveButtons.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports